<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.userName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.userName }}</p>
      <small>Online</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.userName"
          v-lazy="avatarInfo"
          key="onlineImg"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <!-- <div v-lazy-container="{ selector: 'img' }">
        <img
          v-if="activeUserInfo.name"
          key="onlineImg"
          v-bind:data-src="'data:image/jpg;base64,'+ avatarInfo"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        </div>-->
        <!--<img v-if="activeUserInfo.name" key="onlineImg"  :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />-->
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/perfil').catch (err => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Perfil</span>
          </li>
          <li
            v-if="getGroup =='admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/gestao').catch (err => {})"
          >
            <feather-icon icon="TrelloIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Gestão do Sistema</span>
          </li>
          <li
            v-if="getGroup =='admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/usuarios').catch (err => {})"
          >
            <feather-icon icon="UsersIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Usuários</span>
          </li>
           <li
            v-if="getGroup =='admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/faturas').catch (err => {})"
          >
            <feather-icon icon="FileTextIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Faturas</span>
          </li>
            <li
            v-if="getGroup =='admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/cotacoes').catch (err => {})"
          >
            <feather-icon icon="DollarSignIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Cotações</span>
          </li>
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/lixeira').catch (err => {})"
          >
            <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Lixeira</span>
          </li>
           <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/novidades').catch (err => {})"
          >
            <feather-icon icon="BellIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Novidades</span>
          </li>
          <!--
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>-->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { userKey, avatarPhoto } from "@/global";
export default {
  data() {
    return {};
  },

  computed: {
    activeUserInfo() {
      let userInfoLocalStorage = JSON.parse(localStorage.getItem(userKey));
      let user = this.$store.state.user || userInfoLocalStorage;
      return user;
    },
    avatarInfo() {
      let avatarLocalStorage = localStorage.getItem(avatarPhoto);
      let avatar = this.$store.state.avatar || avatarLocalStorage;
      return avatar;
    },
    getGroup() {
      let userInfoLocalStorage = JSON.parse(localStorage.getItem(userKey));
      let userGroup = this.$store.state.user.userGroup || userInfoLocalStorage.userGroup;
      return userGroup;
    }
  },
  methods: {
    async logout() {
      localStorage.removeItem(userKey);
      localStorage.removeItem(avatarPhoto);
      //this.$store.commit("SET_AVATAR", null);
      //this.$store.commit("SET_USER_INFO", null);

      this.$router.push({ name: "page-login" });
    }
  }
};
</script>
